module.exports = __webpack_public_path__ + "static/img/success.e296a4c5.png";